import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WestnetzPageComponent } from './westnetz-page/westnetz-page.component';
import { MaterialModule } from '../material/material.module';
import { ServiceModule } from '../../service/service.module';
import { RouterModule } from '@angular/router';
import { NavigationHeaderComponent } from './navigation-header/navigation-header.component';
import { WestnetzFooterComponent } from './westnetz-footer/westnetz-footer.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        RouterModule,
    ],
    declarations: [
        WestnetzPageComponent,
        NavigationHeaderComponent,
        WestnetzFooterComponent,
    ],
    exports: [
        WestnetzPageComponent,
        NavigationHeaderComponent,
        WestnetzFooterComponent,
    ],
})
export class WestnetzModule {
}
